<div class="widget-content-container qs-zusammenfassung-widget">
  <div slimScroll [scrollEvents]="slimScrollEvents" class="scroll-space h-100">
    @if (dataLoading) {
      <iq-loading-indicator></iq-loading-indicator>
    }
    @if (errMessage && !dataLoading) {
      <div>
        <h4>{{ errMessage | translate }}</h4>
      </div>
    }
    @if (!dataLoading) {
      <div>
        @if (selectData) {
          <iq-single-select-navigation
            class="mb-1"
            [selectData]="selectData"
            (selectionChanged)="onSelectionChanged($event)"
          >
          </iq-single-select-navigation>
        }
        @if (selectedBetriebsstaette) {
          <accordion>
            @if (selectedBetriebsstaette[accordionSections['QsProdukte'].produktKey]; as qsProdukte) {
              <accordion-group
                class="mb-1 mt-2"
                [panelClass]="
                  getAccordionCircleColor(accordionSections['QsProdukte'].produktKey) === 'rang-ampel-rot'
                    ? 'qs-warning'
                    : ''
                "
                [isOpen]="accordionSections['QsProdukte'].isOpen"
                (isOpenChange)="accordionOpenChange($event, 'QsProdukte')"
              >
                <div accordion-heading>
                  <i class="iq-icon-font iq-icon-font-qualitaetssicherung"></i>
                  <span class="header-label">{{ 'WIDGETS.QS_ZUSAMMENFASSUNG.QS' | translate }}</span>
                  <div class="circle-accordion-header float-right">
                    <div class="inner {{ getAccordionCircleColor(accordionSections['QsProdukte'].produktKey) }}">
                      <i
                        class="toggle-arrow float-right fa"
                        [ngClass]="{
                          'fa-chevron-down toggle-arrow-down': accordionSections['QsProdukte'].isOpen && qsProdukte,
                          'fa-chevron-right toggle-arrow-right': !accordionSections['QsProdukte'].isOpen && qsProdukte,
                        }"
                      >
                      </i>
                    </div>
                  </div>
                </div>
                @for (produkt of qsProdukte; track produkt) {
                  <div>
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>
                            <div class="text-bold">{{ produkt.ProduktName }}</div>
                            <span class="text-muted">
                              <span>{{ 'WIDGETS.QS_ZUSAMMENFASSUNG.LIEFERBERECHT' | translate }}: </span>
                              <span
                                ><b>{{ produkt.Lieferberechtigung | lieferberechtigung }}</b></span
                              >
                              @if (produkt.Lieferberechtigung !== 4 && produkt.ZugelassenBis !== null) {
                                <span>
                                  / {{ 'WIDGETS.QS_ZUSAMMENFASSUNG.ZULASSUNG' | translate }}:
                                  <b>{{ produkt.ZugelassenBis | date }}</b>
                                </span>
                              }
                              @if (produkt.Lieferberechtigung === 4 && produkt.Sperrgrund !== null) {
                                <span> ({{ produkt.Sperrgrund }}) </span>
                              }
                            </span>
                          </td>
                          <td>
                            <div class="rang-circle float-right">
                              <div class="inner {{ getCircleColor(produkt.Ampel) }}"></div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                }
              </accordion-group>
            }
            @if (selectedBetriebsstaette[accordionSections['SalmonellenProdukte'].produktKey]; as salmonellenProdukte) {
              <accordion-group
                class="mb-1"
                [isOpen]="accordionSections['SalmonellenProdukte'].isOpen"
                (isOpenChange)="accordionOpenChange($event, 'SalmonellenProdukte')"
              >
                <div accordion-heading>
                  <i class="iq-icon-font iq-icon-font-salmonellenmonitoring"></i>
                  <span class="header-label">{{ 'WIDGETS.QS_ZUSAMMENFASSUNG.SALMO' | translate }}</span>
                  <div class="circle-accordion-header float-right">
                    <div class="inner {{ getAccordionCircleColor('SalmonellenProdukte') }}">
                      <i
                        class="toggle-arrow float-right fa"
                        [ngClass]="{
                          'fa-chevron-down toggle-arrow-down':
                            accordionSections['SalmonellenProdukte'].isOpen && salmonellenProdukte,
                          'fa-chevron-right toggle-arrow-right':
                            !accordionSections['SalmonellenProdukte'].isOpen && salmonellenProdukte,
                        }"
                      >
                      </i>
                    </div>
                  </div>
                </div>
                @for (produkt of salmonellenProdukte; track produkt) {
                  <div>
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>
                            <div class="text-bold">{{ produkt.ProduktName }}</div>
                            <span class="text-muted">
                              @if (produkt.Ampel) {
                                <span>
                                  {{ 'WIDGETS.QS_ZUSAMMENFASSUNG.KAT' | translate }}:
                                  <b>{{ produkt.Ampel / 10 | roemischeZahl }}</b> ({{
                                    produkt.ProzentPositiveProben | number: '1.2-2'
                                  }}
                                  {{ 'MASSEINHEITEN.PROZENT' | translate }}
                                  {{ 'WIDGETS.QS_ZUSAMMENFASSUNG.POS' | translate }}) -
                                  {{ produkt.GueltigVon | date: dateFormat }} -
                                  {{ produkt.GueltigBis | date: dateFormat }}
                                </span>
                              }
                              @if (!produkt.Ampel) {
                                <span
                                  >{{ 'WIDGETS.QS_ZUSAMMENFASSUNG.KAT' | translate }}:
                                  <b>{{ 'WIDGETS.QS_ZUSAMMENFASSUNG.KEINE' | translate }}</b></span
                                >
                              }
                            </span>
                          </td>
                          <td>
                            <div class="rang-circle float-right">
                              <div class="inner {{ getCircleColor(produkt.Ampel) }}"></div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                }
              </accordion-group>
            }
            @if (selectedBetriebsstaette[accordionSections['TgiProdukte'].produktKey]; as tgiProdukte) {
              <accordion-group
                class="mb-1"
                [isOpen]="accordionSections['TgiProdukte'].isOpen"
                (isOpenChange)="accordionOpenChange($event, 'TgiProdukte')"
              >
                <div accordion-heading>
                  <i class="iq-icon-font iq-icon-font-tgi"></i>
                  <span class="header-label tgi">{{ 'WIDGETS.QS_ZUSAMMENFASSUNG.TGI' | translate }}</span>
                  <div class="circle-accordion-header float-right">
                    <div class="inner {{ getAccordionTgiCircleColor() }}">
                      <i
                        class="toggle-arrow float-right fa"
                        [ngClass]="{
                          'fa-chevron-down toggle-arrow-down': accordionSections['TgiProdukte'].isOpen && tgiProdukte,
                          'fa-chevron-right toggle-arrow-right':
                            !accordionSections['TgiProdukte'].isOpen && tgiProdukte,
                        }"
                      >
                      </i>
                    </div>
                  </div>
                </div>
                @for (produkt of tgiProdukte; track produkt) {
                  <div>
                    <div class="row">
                      <div class="col-12 pl-2 pr-2">
                        <div class="tgi-info pl-2 pr-2">
                          <div>{{ 'WIDGETS.QS_ZUSAMMENFASSUNG.SCHLACHTHOF' | translate }}</div>
                          <div [tooltip]="tgiInfoBefundgruppenText" [container]="'body'">
                            {{ tgiInfoBefundgruppenText }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-12">
                        <span class="text-bold">{{ produkt.ProduktName }}: </span>
                        <span
                          >{{ produkt.ZeitraumVon | date: dateFormat }} -
                          {{ produkt.ZeitraumBis | date: dateFormat }}</span
                        >
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        @for (schlachtbetrieb of produkt.Schlachtbetriebe; track schlachtbetrieb) {
                          <div class="mt-2">
                            <div>{{ schlachtbetrieb.SchlachtbetriebName }}</div>
                            <div>
                              @if (schlachtbetrieb.Atemwegsgesundheit) {
                                <div
                                  [class]="
                                    getTgiBefundgruppenColor(schlachtbetrieb?.Atemwegsgesundheit) +
                                    ' d-inline-block tgi-befundgruppe'
                                  "
                                >
                                  {{ schlachtbetrieb.Atemwegsgesundheit.Wert }}
                                </div>
                              } @else {
                                <div class="d-inline-block tgi-befundgruppe">-</div>
                              }
                              <div class="d-inline-block">&nbsp;/&nbsp;</div>
                              @if (schlachtbetrieb.Organgesundheit) {
                                <div
                                  [class]="
                                    getTgiBefundgruppenColor(schlachtbetrieb?.Organgesundheit) +
                                    ' d-inline-block tgi-befundgruppe'
                                  "
                                >
                                  {{ schlachtbetrieb.Organgesundheit.Wert }}
                                </div>
                              } @else {
                                <div class="d-inline-block tgi-befundgruppe">-</div>
                              }
                              <div class="d-inline-block">&nbsp;/&nbsp;</div>
                              @if (schlachtbetrieb.Gliedmassengesundheit) {
                                <div
                                  [class]="
                                    getTgiBefundgruppenColor(schlachtbetrieb?.Gliedmassengesundheit) +
                                    ' d-inline-block tgi-befundgruppe'
                                  "
                                >
                                  {{ schlachtbetrieb.Gliedmassengesundheit.Wert }}
                                </div>
                              } @else {
                                <div class="d-inline-block tgi-befundgruppe">-</div>
                              }
                              <div class="d-inline-block">&nbsp;/&nbsp;</div>
                              @if (schlachtbetrieb.Unversehrtheit) {
                                <div
                                  [class]="
                                    getTgiBefundgruppenColor(schlachtbetrieb?.Unversehrtheit) +
                                    ' d-inline-block tgi-befundgruppe'
                                  "
                                >
                                  {{ schlachtbetrieb.Unversehrtheit.Wert }}
                                </div>
                              } @else {
                                <div class="d-inline-block tgi-befundgruppe">-</div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </accordion-group>
            }
            @if (selectedBetriebsstaette[accordionSections['AntibiotikaProdukte'].produktKey]; as antibiotikaProdukte) {
              <accordion-group
                class="mb-1"
                [isOpen]="accordionSections['AntibiotikaProdukte'].isOpen"
                (isOpenChange)="accordionOpenChange($event, 'AntibiotikaProdukte')"
              >
                <div accordion-heading>
                  <i class="iq-icon-font iq-icon-font-antibiotikamonitoring"></i>
                  <span class="header-label">{{ 'WIDGETS.QS_ZUSAMMENFASSUNG.ANTI' | translate }}</span>
                  <div class="circle-accordion-header float-right">
                    <div
                      class="inner {{ getAccordionCircleColor(accordionSections['AntibiotikaProdukte'].produktKey) }}"
                    >
                      <i
                        class="toggle-arrow float-right fa"
                        [ngClass]="{
                          'fa-chevron-down toggle-arrow-down':
                            accordionSections['AntibiotikaProdukte'].isOpen && antibiotikaProdukte,
                          'fa-chevron-right toggle-arrow-right':
                            !accordionSections['AntibiotikaProdukte'].isOpen && antibiotikaProdukte,
                        }"
                      >
                      </i>
                    </div>
                  </div>
                </div>
                @for (produkt of antibiotikaProdukte; track produkt) {
                  <div>
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>
                            <div class="text-bold">{{ produkt.ProduktName }}</div>
                            @if (produkt.TherapieIndex) {
                              <span class="text-muted">
                                {{ 'WIDGETS.QS_ZUSAMMENFASSUNG.THERAPIEINDEX' | translate }}
                                <b>{{ produkt.TherapieIndex | antibiotikaTherapieindex }}</b> -
                                {{ produkt.GueltigVon | date: dateFormat }} -
                                {{ produkt.GueltigBis | date: dateFormat }}
                              </span>
                            }
                          </td>
                          <td>
                            <div class="rang-circle float-right">
                              <div class="inner {{ getCircleColor(produkt.Ampel) }}"></div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                }
              </accordion-group>
            }
          </accordion>
        }
      </div>
    }
  </div>
</div>

<!-- Edit widget -->
<div class="widget-bearbeiten-container disabled"></div>
